<template>
  <el-dialog :title="$t('message.productInquiry')" :visible.sync="dialogVisible" width="560px"
    :close-on-click-modal="false" append-to-body @closed="reset">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item :label="$t('message.inquiryQuestion')" prop="question">
        <el-input v-model="form.question" type="textarea" :rows="6" maxlength="1000" show-word-limit
          :placeholder="$t('message.inquiryQuestionPlaceholder')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">{{ $t('message.ok') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'GoodsInquiryCreate',
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      orderDetailIds: [],
      form: { question: '' },
      rules: {
        question: [{ required: true, message: this.$t('message.pleaseEnterInquiryQuestion'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 保存当前勾选的订单明细 ID，弹窗确认时统一提交同一个询盘问题。
    open(orderDetailIds) {
      this.orderDetailIds = orderDetailIds.slice()
      this.form.question = ''
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const question = this.form.question.trim()
        if (!question) {
          this.$message.error(this.$t('message.pleaseEnterInquiryQuestion'))
          return
        }
        this.submitting = true
        this.$api.orderApi.purchaseGoodsInquiryBatchCreate({
          order_detail_ids: this.orderDetailIds,
          question
        }).then(res => {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('saved')
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    reset() {
      this.orderDetailIds = []
      this.form.question = ''
      this.submitting = false
    }
  }
}
</script>
